module.exports = __webpack_public_path__ + "static/media/unterweisung_true_passive.19e62185.jpg";